type BrandId = string | number;

export const telegramWebAppEnabledByBrand: Readonly<Record<number, boolean>> = {
    31: true,
    33: true,
    35: true,
    37: true,
    39: true,
    47: true,
    49: true,
    61: true,
    71: true,
};

type TelegramWindow = Window & {
    Telegram?: {
        WebApp?: {
            expand?: () => void;
        };
    };
};

let scriptLoad: Promise<void> | null = null;

export const expandTelegramWebApp = (brandId: BrandId): void => {
    if (
        typeof window === 'undefined' ||
        typeof document === 'undefined' ||
        telegramWebAppEnabledByBrand[Number(brandId)] !== true
    ) {
        return;
    }

    const browserWindow = window as TelegramWindow;
    const expand = () => browserWindow.Telegram?.WebApp?.expand?.();

    if (browserWindow.Telegram?.WebApp?.expand) {
        expand();
        return;
    }

    if (!scriptLoad) {
        scriptLoad = new Promise<void>((resolve, reject) => {
            const script = document.createElement('script');
            script.id = 'telegram-web-app-script';
            script.src = 'https://telegram.org/js/telegram-web-app.js';
            script.async = true;
            script.onload = () => resolve();
            script.onerror = () => {
                script.remove();
                scriptLoad = null;
                reject(new Error('Failed loading Telegram WebApp script'));
            };
            document.head.appendChild(script);
        });
    }

    void scriptLoad.then(expand).catch((error: unknown) => {
        console.warn('Unable to expand Telegram WebApp:', error);
    });
};
